var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: _vm.$t("dealersDispatch.dealer")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "dealerId", $$v);
      },
      expression: "listQuery.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1), _c("VueCtkDateTimePicker", {
    staticClass: "filter-item",
    attrs: {
      range: "",
      formatted: "DD-MM-YYYY",
      "custom-shortcuts": _vm.shortcuts
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      icon: "el-icon-search",
      size: "mini"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleExcelDownload
    }
  }, [_vm._v(" Export as Excel ")])], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading || _vm.adjustmentsLoading,
      expression: "listLoading || adjustmentsLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      "span-method": _vm.objectSpanMethod,
      border: "",
      fit: "",
      "highlight-current-row": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "120",
      align: "center",
      label: "Invoice Number"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.ordersDispatchId ? _c("el-link", {
          attrs: {
            type: "primary",
            target: "_blank"
          },
          on: {
            click: function ($event) {
              return _vm.viewDispatchInvoice(scope.row.ordersDispatchId);
            }
          }
        }, [_vm._v(" " + _vm._s(scope.row.ordersDispatch.invoiceNumber) + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "350",
      align: "center",
      label: "Dealer Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(scope.row.ordersDispatch.dealer.name))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "180",
      align: "center",
      label: "Product Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.isWrongProduct ? _c("el-tooltip", {
          attrs: {
            content: "Wrong product, check the comments for actual product",
            placement: "top"
          }
        }, [_c("b", {
          staticStyle: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(scope.row.ordersProduct.product.name) + " ")])]) : _c("b", [_vm._v(" " + _vm._s(scope.row.ordersProduct.product.name) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      align: "center",
      label: "Variation Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.isWrongProduct ? _c("el-tooltip", {
          attrs: {
            content: "Wrong product, check the comments for actual product",
            placement: "top"
          }
        }, [_c("b", {
          staticStyle: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(scope.row.ordersProduct.productsVariation.name) + " ")])]) : _c("b", [_vm._v(" " + _vm._s(scope.row.ordersProduct.productsVariation.name) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "130",
      align: "center",
      label: "Quantity Dispatched"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            type: "primary",
            round: "",
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(scope.row.quantity) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "130",
      align: "center",
      label: "Quantity Received"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            type: "primary",
            round: "",
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(scope.row.quantityReceived) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "130",
      align: "center",
      label: "Difference Quantity"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: `Quantity Dispatched: ${scope.row.quantity}  Quantity Received: ${scope.row.quantityReceived}`,
            placement: "top"
          }
        }, [_c("el-button", {
          attrs: {
            type: "primary",
            round: "",
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(Math.abs(scope.row.quantity - scope.row.quantityReceived)) + " ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "260",
      align: "center",
      label: "Comments"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(_vm.showComments(scope.row)))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "180",
      align: "center",
      label: "Source Adjustment Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tag", {
          attrs: {
            type: scope.row.sourceAdjustmentType === "Credit Note-Item Wise" ? "success" : scope.row.sourceAdjustmentType === "Debit Note-Item Wise" ? "danger" : "info"
          }
        }, [_vm._v(" " + _vm._s(scope.row.sourceAdjustmentType) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "180",
      align: "center",
      label: "Destination Adjustment Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tag", {
          attrs: {
            type: scope.row.destinationAdjustmentType === "Credit Note-Item Wise" ? "success" : scope.row.destinationAdjustmentType === "Debit Note-Item Wise" ? "danger" : "info"
          }
        }, [_vm._v(" " + _vm._s(scope.row.destinationAdjustmentType) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: [_vm.SUPER_ADMIN, _vm.ACCOUNT_MANAGER],
      expression: "[SUPER_ADMIN,ACCOUNT_MANAGER]"
    }],
    attrs: {
      align: "center",
      label: "Actions",
      width: "110",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [(_vm.isSuperAdmin || _vm.isTushar) && !scope.row.areAdjustmentMade && !scope.row.ordersDispatch.areAdjustmentMade ? _c("el-button", {
          attrs: {
            type: "warning",
            size: "mini",
            icon: "el-icon-check"
          },
          on: {
            click: function ($event) {
              return _vm.handleAdjustments(scope.row, scope.$index);
            }
          }
        }) : _vm._e()];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };